export const FIELD_BORDER = {
  default: "border-gray-200",
  hinted: "border-indigo-200",
  errored: "border-red-600 ring-2 ring-red-400/25",
} as const;

export const FIELD_TEXT = {
  default: "text-gray-800",
  hinted: "text-indigo-600",
  disabled: "text-gray-500",
} as const;
